/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AwsEc2AmiConvertResult {
  /**
  * ID of the restored AMI.
  */
  'imageId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "imageId",
      "baseName": "imageId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsEc2AmiConvertResult.attributeTypeMap;
  }

  public constructor() {
  }
}

